import { useTranslation } from "react-i18next";

const Admin = () => {
  const { t } = useTranslation();
  const adminNavArray = [
    // ** Dashboard ** //
    {
      id: "dashboard",
      title: t("navigation.admin.dashboard"),
      tourClass: "joy-dash-admin",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="2" width="9" height="9" rx="2" fill="#4F46E5" />
          <rect x="13" y="2" width="9" height="9" rx="2" fill="#06B6D4" />
          <rect x="2" y="13" width="9" height="9" rx="2" fill="#10B981" />
          <rect x="13" y="13" width="9" height="9" rx="2" fill="#F59E0B" />
          <circle cx="6.5" cy="6.5" r="2" fill="white" />
          <circle cx="17.5" cy="6.5" r="2" fill="white" />
          <circle cx="6.5" cy="17.5" r="2" fill="white" />
          <circle cx="17.5" cy="17.5" r="2" fill="white" />
        </svg>
      ),
      navLink: (workspaceId) => `/a/ws/${workspaceId}/dashboard`,
    },
    // ** History ** //
    {
      id: "history",
      title: t("navigation.admin.history"),
      tourClass: "joy-history-admin",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="9" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2" />
          <path d="M12 7V12L15 14" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 4V9H9" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 9C5.5 5.5 8.5 3 12 3C16.97 3 21 7.03 21 12" stroke="#10B981" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="5" r="1" fill="#F59E0B" />
          <circle cx="19" cy="12" r="1" fill="#F59E0B" />
          <circle cx="12" cy="19" r="1" fill="#F59E0B" />
          <circle cx="5" cy="12" r="1" fill="#F59E0B" />
        </svg>
      ),
      navLink: (workspaceId) => `/a/ws/${workspaceId}/history/chats`,
    },
    // ** Trash ** //
    {
      id: "trash",
      title: t("navigation.admin.trash"),
      tourClass: "joy-trash-admin",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 7H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V7Z" fill="#FEE2E2" stroke="#EF4444" strokeWidth="1.5" />
          <path d="M3 7H21" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
          <path d="M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M10 11V17" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M14 11V17" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="19" cy="5" r="2.5" fill="#DCFCE7" stroke="#10B981" strokeWidth="1" />
          <path d="M18 5L19 6L20 4.5" stroke="#10B981" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      navLink: (workspaceId) => `/a/ws/${workspaceId}/trash/chats`,
    },
    // ** Team ** //
    {
      id: "team",
      title: t("navigation.admin.team"),
      tourClass: "joy-team-admin",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9" cy="7" r="3.5" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2" />
          <circle cx="9" cy="7" r="2" fill="#3B82F6" />
          <path d="M1 19V17C1 15.3431 2.34315 14 4 14H14C15.6569 14 17 15.3431 17 17V19" fill="#DBEAFE" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" />
          <circle cx="17" cy="7" r="2.5" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="1.5" />
          <path d="M23 19V17.5C23 16.1193 22.1046 14.9448 20.8954 14.5" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="19" cy="4" r="1.5" fill="#10B981" />
          <path d="M18.5 4L19 4.5L19.5 3.5" stroke="white" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      navLink: (workspaceId) => `/a/ws/${workspaceId}/team`,
    },
    // ** Prompts ** //
    {
      id: "prompts",
      title: t("navigation.admin.prompts") || "Prompts",
      tourClass: "joy-prompts-admin",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" fill="#F3E8FF" stroke="#A855F7" strokeWidth="2"/>
          <path d="M7 8H17" stroke="#A855F7" strokeWidth="2" strokeLinecap="round"/>
          <path d="M7 12H14" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round"/>
          <path d="M7 16H11" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="17" cy="17" r="3" fill="#A855F7"/>
          <path d="M16 17L17 18L18.5 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="4" cy="8" r="1" fill="#F59E0B"/>
          <circle cx="4" cy="12" r="1" fill="#10B981"/>
          <circle cx="4" cy="16" r="1" fill="#3B82F6"/>
        </svg>
      ),
      navLink: (workspaceId) => `/a/ws/${workspaceId}/prompts`,
    },
  ];
  return { adminNavArray };
};

export default Admin;
